import { Card, Group, Stack, Text, UnstyledButton } from '@mantine/core'
import type { AttachmentResponse, PropertyWithRelations } from '@markku/types'
import { IconFileTypePdf } from '@tabler/icons-react'

interface CertificatesCardProps {
  visitId: number
  property?: PropertyWithRelations
}

const getCertificateName = (attachment: AttachmentResponse): string => {
  const certificateType = attachment.metadata?.certificateType

  if (certificateType === 'nuohoustodistus') {
    return 'Nuohoustodistus'
  }

  return attachment.filename || 'Todistus'
}

export function CertificatesCard({ visitId, property }: CertificatesCardProps) {
  if (!property?.attachments) {
    return null
  }

  // Filter for certificate attachments related to this visit
  const certificates = property.attachments.filter(
    (att) =>
      att.metadata?.type === 'certificate' && att.metadata?.visitId === visitId,
  )

  if (certificates.length === 0) {
    return null
  }

  return (
    <Card withBorder>
      <Text size="lg" fw={600} mb="md">
        Todistukset
      </Text>

      <Stack gap="xs">
        {certificates.map((cert) => (
          <UnstyledButton
            key={cert.id}
            component="a"
            href={cert.downloadUrl || undefined}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              padding: 'var(--mantine-spacing-xs)',
              borderRadius: 'var(--mantine-radius-sm)',
              border: '1px solid var(--mantine-color-gray-3)',
              transition: 'background-color 0.2s',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor =
                'var(--mantine-color-gray-0)'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent'
            }}
          >
            <Group gap="sm">
              <IconFileTypePdf size={20} />
              <Stack gap={0} style={{ flex: 1 }}>
                <Text size="sm" fw={500}>
                  {getCertificateName(cert)}
                </Text>
                {cert.description && (
                  <Text size="xs" c="dimmed">
                    {cert.description}
                  </Text>
                )}
              </Stack>
            </Group>
          </UnstyledButton>
        ))}
      </Stack>
    </Card>
  )
}
